import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import Button from '~Scenes/Tables/Components/Button';

const Wrapper = styled(Button)`
  margin-top: 30px;
`;

interface Props {
  onClick: () => void;
  disabled: boolean;
  background: string;
}

const CancelButton: React.FC<Props> = ({ onClick, disabled, children, background }) => {
  const [visible, setVisible] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 1000);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <Wrapper
      onClick={onClick}
      slim
      background="var(--colorUIRed)"
      disabled={disabled}
      style={{ backgroundColor: background }}>
      {children}
    </Wrapper>
  );
};

export default CancelButton;
